import type { FC } from 'react';
import { Box, Grid, } from '@material-ui/core';
import CurvaProduccionTableRemesa from './CurvaProduccionTableRemesa';
import CurvaProduccionChartLineRemesa from './CurvaProduccionChartLineRemesa';

const CurvaProduccionRemesa: FC<{ headers: any[], data: any }> = ({ headers, data }) => (
  <>
    <Box p={0}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <CurvaProduccionTableRemesa data={data} headers={headers} />
        </Grid>
        <Grid item xs={12} md={12}>
          <CurvaProduccionChartLineRemesa data={data} headers={headers} title="Real Acum. Vs Fcst Acum." />
        </Grid>
      </Grid>
    </Box>
  </>
);

export default CurvaProduccionRemesa;
